/// <reference types="@emotion/react/types/css-prop" />
import {
  ContentModule,
  ModuleProperties,
  useParsedText,
  useShowInstructions,
} from '@backstage-components/base';
import {css} from '@emotion/react';
import {useSubscription} from 'observable-hooks';
import {FC, useEffect, useState} from 'react';
import {ComponentDefinition, SchemaType} from './RichTextDefinition';

export interface IRichTextProps extends ModuleProperties {
  content: string;
}

export type RichTextComponentDefinition = ContentModule<
  'RichText',
  IRichTextProps & SchemaType
>;

export const RichTextComponent: FC<RichTextComponentDefinition> = (
  definition
) => {
  const {content, styleAttr} = definition.props;

  const [contentString, setContentString] = useState(content);

  useEffect(() => {
    setContentString(content);
  }, [content]);

  const {observable} = useShowInstructions(
    ComponentDefinition.instructions,
    definition
  );
  useSubscription(observable, (inst) => {
    switch (inst.type) {
      case 'RichText:set-content': {
        setContentString(inst.meta.content);
        return;
      }
      default:
        return;
    }
  });

  const children = useParsedText(contentString);

  return (
    <div
      id={definition.id}
      css={css`
        ${definition.style}
        ${styleAttr}
      `}
    >
      {children}
    </div>
  );
};
